// extracted by mini-css-extract-plugin
module.exports = {"item":"Style_item__204aj","title":"Style_title__D2v3v","detail":"Style_detail__Lz6jr"};